exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".catalog-preview-container {\n  height: calc(var(--vh, 1vh) * 100); }\n", ""]);

// exports
